<template>
  <div class="protection-page">
    <!-- 未成年人信息保护规则内容 -->
    <div class="protection-content">
      <div class="content-container">
        <h1 class="main-title">星果未成年人信息保护规则和监护人须知</h1>
        <p class="update-time">更新时间：2022年08月25日</p>

        <section class="section intro-section">
          <p>欢迎您选择享用【星果】平台（以下简称"我们"或"平台"），我们深知儿童（指未满十四周岁的未成年人，下同）个人信息和隐私安全的重要性。我们希望通过《星果未成年人信息保护规则和监护人须知》（以下简称"本规则"）说明我们在收集和使用儿童个人信息时对应的处理规则等相关事宜。在使用平台产品和服务前，请儿童、儿童的父母或其他监护人（以下统称"监护人"）务必仔细阅读并透彻理解本规则，<strong>特别是以粗体/下划线标识的条款应重点阅读</strong>，在确认充分理解并同意全部条款后再开始使用。我们将为监护人提供更丰富的管理手段，确保儿童的信息收集、使用在监管人的监督下进行。</p>
        </section>

        <section class="section">
          <h2>1.监护人特别说明</h2>
          <p>如果您的被监护人是未满14周岁的儿童，他/她注册、使用本产品，需要经过您的明确同意，同时我们将根据本规则采取特殊措施保护我们获得的您孩子的个人信息。也请帮助我们保护您孩子的个人信息和隐私安全，要求他们在您的监护下共同阅读并接受本规则，且应在您的同意和指导下使用本产品服务、提交个人信息。<strong>如果您不同意本规则的内容，将可能导致部分本产品服务无法正常运行，或者无法达到我们拟达到的服务效果，您应要求您的孩子立即停止访问/使用本产品服务。</strong>您于线上点击同意本规则或通过其他方式同意本规则，表示您同意我们按照本规则收集、使用、存储、共享、转移和公开您孩子的个人信息。</p>
          <p>本规则约定了在不同场景下我们处理儿童信息的方式，但只有当您孩子使用或开启相关功能或使用服务时，为实现相关功能、服务，我们才会处理相关信息。如您孩子不开启相关功能或使用相关服务，则我们不会处理您孩子对应的个人信息。除本规则外，在特定产品中，我们还会通过即时告知如弹窗、页面提示等方式，向您说明该产品特定的信息收集目的、范围及使用方式，这些即时告知内容构成本规则的一部分，并与本规则具有同等效力。</p>

          <h3>1.1儿童特别说明</h3>
          <p>我们建议：任何儿童参加网上活动都应事先取得监护人的同意。<strong>如果您是儿童，请通知您的监护人共同阅读本规则，并在您使用本产品服务、提交个人信息之前，寻求您的监护人的同意和指导。</strong></p>
          <p>本规则适用于我们在中华人民共和国境内通过网络从事收集、使用、存储、共享、转移和公开儿童个人信息等活动。 在儿童个人信息保护规则方面，本规则与《星果隐私政策》、《星果未成年人个人信息保护规则和监护人须知》正文条款存在不一致的，本规则条款优先适用，如本规则中未提及的，则以《星果隐私政策》、《星果未成年人个人信息保护规则和监护人须知》正文条款为准。</p>
        </section>

        <section class="section">
          <h2>2.保护未成年人个人信息安全</h2>

          <h3>2.1严格限制手机未成年人个人信息的类型</h3>
          <p>a.我们会基于确保多元、优质内容更好地触达未成年人的目的，手机设备信息、内容数据等最基础功能所必需的信息。</p>
          <p>b.为保障优质内容的质量并向您推荐可能感兴趣的内容及相关信息，我们可能会收集相关必要的日志信息。我们在收集您的信息前会征得您的同意，我们将收集点赞、收藏、关注等信息，我们不会收集未经您授权的信息。</p>

          <h3>2.2严格限定未成年个人信息的使用目的</h3>
          <p>a.收集信息将不会被用于任何商业目的，不会基于任何商业目的而与第三方共享。</p>
          <p>b.收集的部分设备信息、网络信息可能会被用于安全与反作弊目的，但是我们不会将以这些目的收集的信息用于其他不相关的领域。</p>

          <h3>2.3严格的措施和制度保护未成年人个人信息安全</h3>
          <p>a．我们在境内运营过程中收集和产生的未成年人个人信息存储于中华人民共和国境内，不会传输或存储至境外。</p>
          <p>b.存储所收集未成年人的浏览日志信息为6个月，但是发法规另行规定的除外。</p>
          <p>c.我们会使用高强度的加密技术、匿名化处理及相关合理可行的手段保护未成年人的信息，并使用安全保护机制防止恶意攻击。</p>
          <p>d.我们会建立专门的安全部门、专门针对未成年人信息的安全管理制度、数据安全流程保障未成年人信息安全。我们采取严格的数据使用和访问制度，确保只有授权人员才可以访问，并适时对数据合计数进行安全审计。</p>
        </section>

        <section class="section">
          <h2>3.保障未成年人健康使用</h2>
          <p>我们一向非常重视和保护未成年人特别是儿童的身心健康，并采取相关技术措施防止未成年人特别是儿童沉迷网络。我们会提供更多远与适合未成年人的优质作品，让未成年人看到更多优质内容，拓展未成年人的视野。</p>
        </section>

        <section class="section">
          <h2>4.第三方服务</h2>
          <p>本产品服务可能为儿童接入或链接至第三方提供的社交媒体或其他服务（包括网站或其他服务形式）。请查阅《星果隐私政策》"我们可能共享、转移或公开您的个人信息"章节，详细了解我们接入或链接的第三方服务类型。</p>
          <p>该等第三方社交媒体或其他服务由相关的第三方负责运营。儿童使用该等第三方的社交媒体服务或其他服务（包括儿童向该等第三方提供的任何信息），须受第三方自己的服务条款及信息保护声明（而非本规则）约束，监护人和儿童需要仔细阅读其条款。本规则仅适用于我们所收集的个人信息，并不适用于任何第三方提供的服务或第三方的信息使用规则。如监护人和儿童发现这些第三方社交媒体或其他服务存在风险时，建议终止相关操作以保护儿童的合法权益并及时与我们取得联系。</p>
        </section>

        <section class="section">
          <h2>5.本规则修订</h2>
          <p>为了提供更好的服务，我们将会根据本产品服务的更新情况及法律法规的相关要求适时修改本规则的条款，该等修改构成本规则的一部分。如该等更新造成监护人和儿童在本规则下权利的实质减少或重大变更，我们将在本规则生效前通过网站公告、推送通知、弹窗提示或其他方式来通知，监护人如果不同意该等变更，可以选择要求儿童停止使用本产品服务。</p>
          <p>我们的任何修改都会将用户的满意度置于首位。我们鼓励监护人和儿童在每次使用本产品服务时都查阅我们的《星果未成年人个人信息保护规则及监护人须知》。</p>
        </section>

        <section class="section">
          <h2>6.如何联系我们</h2>
          <p>如监护人和儿童有关于网络信息安全的投诉和举报，或对本规则、措施的相关事宜有任何问题、意见或建议，请随时与我们产品内客服联系，或者可发送邮件至<a href="mailto:xingyuwanxiang@126.com">xingyuwanxiang@126.com</a>。</p>
          <p>一般情况下，我们将在收到问题、意见或建议，验证监您的份后的，会根据您的请求和法律法规的规定进行处理。</p>
        </section>
      </div>
    </div>

    <!-- 底部 -->
    <footer class="footer">
      <div class="footer-container">
        <div class="footer-links">
          <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">
            京ICP备2025135199号-1
          </a>
        </div>
        <div class="footer-copyright">
          <p>主办单位：北京星域万象科技有限公司</p>
          <p>&copy; 2025 星果. All rights reserved.</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'MinorProtection'
})
export default class MinorProtection extends Vue {
}
</script>

<style scoped lang="scss">
.protection-page {
  font-family: "Helvetica Neue", Arial, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif;
  color: #333;
  background: #fff;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* ========== 未成年人信息保护规则内容 ========== */
.protection-content {
  flex: 1;
  padding: 40px 20px 60px;
  background: #f8f9fa;
}

.content-container {
  max-width: 900px;
  margin: 0 auto;
  background: #fff;
  padding: 60px;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.main-title {
  font-size: 36px;
  font-weight: bold;
  color: #2c3e50;
  text-align: center;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 2px solid #67c23a;
}

.update-time {
  text-align: center;
  color: #909399;
  font-size: 14px;
  margin-bottom: 40px;
}

.intro-section {
  background: #f0f9eb;
  padding: 30px;
  border-radius: 8px;
  border-left: 4px solid #67c23a;
  margin-bottom: 40px;

  p {
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.section {
  margin-bottom: 50px;

  h2 {
    font-size: 26px;
    font-weight: bold;
    color: #2c3e50;
    margin-bottom: 24px;
    padding-left: 16px;
    border-left: 4px solid #67c23a;
  }

  h3 {
    font-size: 20px;
    font-weight: bold;
    color: #34495e;
    margin: 30px 0 20px 0;
  }

  h4 {
    font-size: 18px;
    font-weight: bold;
    color: #5a6c7d;
    margin: 24px 0 16px 0;
  }

  p {
    font-size: 16px;
    line-height: 2;
    color: #5a6c7d;
    margin-bottom: 16px;
    text-align: justify;
  }

  .note {
    background: #f0f9eb;
    border-left: 4px solid #67c23a;
    padding: 16px 20px;
    margin: 20px 0;
    border-radius: 4px;
  }

  strong {
    color: #2c3e50;
    font-weight: 600;
  }

  a {
    color: #67c23a;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}

/* ========== 底部 ========== */
.footer {
  background: #2c3e50;
  padding: 50px 40px;
  margin-top: auto;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
}

.footer-links {
  margin-bottom: 20px;

  a {
    color: #ecf0f1;
    text-decoration: none;
    font-size: 14px;
    transition: color 0.3s;

    &:hover {
      color: #67c23a;
    }
  }
}

.footer-copyright {
  p {
    color: #95a5a6;
    font-size: 13px;
    margin: 10px 0;
    line-height: 1.6;
  }
}

/* ========== 响应式设计 ========== */
@media (max-width: 1024px) {
  .content-container {
    padding: 40px;
  }

  .main-title {
    font-size: 30px;
  }

  .section {
    h2 {
      font-size: 24px;
    }

    h3 {
      font-size: 18px;
    }

    h4 {
      font-size: 16px;
    }
  }
}

@media (max-width: 768px) {
  .protection-content {
    padding: 30px 15px 40px;
  }

  .content-container {
    padding: 30px 24px;
  }

  .main-title {
    font-size: 26px;
    margin-bottom: 16px;
  }

  .intro-section {
    padding: 20px;
  }

  .section {
    margin-bottom: 40px;

    h2 {
      font-size: 22px;
      margin-bottom: 20px;
    }

    h3 {
      font-size: 18px;
      margin: 24px 0 16px 0;
    }

    h4 {
      font-size: 16px;
      margin: 20px 0 14px 0;
    }

    p {
      font-size: 15px;
      line-height: 1.8;
    }
  }

  .footer {
    padding: 40px 20px;
  }
}

@media (max-width: 480px) {
  .content-container {
    padding: 24px 16px;
  }

  .main-title {
    font-size: 22px;
    margin-bottom: 12px;
  }

  .update-time {
    margin-bottom: 30px;
  }

  .intro-section {
    padding: 16px;
  }

  .section {
    h2 {
      font-size: 20px;
      padding-left: 12px;
    }

    h3 {
      font-size: 17px;
    }

    h4 {
      font-size: 15px;
    }

    p {
      font-size: 14px;
      line-height: 1.8;
    }
  }
}
</style>
